// Authoritative source of ALL hydrated WhatsApp chat models.
//
// WhatsApp keeps every loaded chat in `Store.Chat._index` even after the label
// filter mutates `Store.Chat._models` down to a filtered subset (or empties it).
// The previous label filter snapshotted `_models` ONCE into a module-scoped var;
// if that first snapshot landed while `_models` was momentarily empty, it was
// poisoned to `[]` forever and every later filter wiped the whole chat list
// unrecoverably. Sourcing the baseline from the index each time makes the filter
// crash-proof: it can never return an empty set while chats actually exist.
//
// Kept React/store-free so the recoverability guarantee is unit-testable.
export function getAllChatModels(Store: any): any[] {
    const chat = Store?.Chat;
    const fromIndex = chat && chat._index ? Object.values(chat._index) : [];
    if (fromIndex.length) return fromIndex;
    if (chat && chat._models && chat._models.length) return [...chat._models];
    const coll = Store && Store.ChatCollection && Store.ChatCollection._models;
    if (coll && coll.length) return [...coll];
    return [];
}
